import { i18n } from './../../../../i18n';

export const NO_LIMIT = {
  label: i18n.t('common_no_limit') as string,
  value: 'NO_LIMIT',
};
  
export interface ITreeOption {
  id: string | number;
  label: string;
  value?: string | number;
  children?: ITreeOption[];
  parentId?: string | number;
}
